import { searchEntities } from '../../store/selectors/search';

export const selectCommonIssues = state => searchEntities(
  state,
  'commonIssues',
  ['subject', 'description', 'itemName', 'userName', 'issueTypeName']
);
